import React, { FunctionComponent } from 'react';

import { notify as notifyAction } from '@ps-int/ps-components/src/notifications/slice';

import { NOTIFICATIONS_MAP } from '../../../../../shared/features/notifications/ps-notifications';
import { i18n } from '../../../../../shared/helpers/i18n';
import { useActions } from '../../../../../shared/hooks';
import { ShareDesktopStatus } from '../../../constants';
import { IndicatorDotColor, NotificationId } from '../../../types';
import { ToolbarOption } from '../toolbar-option';

export interface ShareDesktopOptionProps {
    status?: ShareDesktopStatus;
    onToggleShareScreen?: () => void;
    disabled?: boolean;
    dotColor?: IndicatorDotColor;
}

const ICON_NAME_BY_STATUS = {
    [ShareDesktopStatus.SHARING]: 'shareScreenProcess',
    [ShareDesktopStatus.UNSHARING]: 'shareScreen',
    [ShareDesktopStatus.BLOCKED]: 'shareScreenBlocked',
} as const;

export const ShareDesktopOption: FunctionComponent<ShareDesktopOptionProps> = ({
    status = ShareDesktopStatus.UNSHARING,
    onToggleShareScreen,
    ...props
}) => {
    const { notify } = useActions({
        notify: notifyAction,
    });

    const onBlockedClick = () => notify(NOTIFICATIONS_MAP[NotificationId.NO_PERMISSION_TO_SHARE_DESKTOP]());

    return (
        <ToolbarOption
            key="shareDesktopOption"
            onClick={status !== ShareDesktopStatus.BLOCKED ? onToggleShareScreen : onBlockedClick}
            content={
                status === ShareDesktopStatus.SHARING
                    ? i18n('toolbar', 'share-desktop-button-stop-title')
                    : i18n('toolbar', 'share-desktop-button-title')
            }
            title={
                status === ShareDesktopStatus.SHARING
                    ? i18n('share-screen', 'stop-demonstration')
                    : i18n('share-screen', 'start-demonstration')
            }
            iconName={ICON_NAME_BY_STATUS[status]}
            {...props}
        />
    );
};
